<template>
  <div id="homeWrapper">
    <home-banner></home-banner>
    <carousel></carousel>
    <bottom-banner></bottom-banner>
  </div>
</template>

<script>
import HomeBanner from '../components/HomeBanner'
import BottomBanner from '../components/BottomBanner'
import Carousel from '../components/Carousel'
export default {
  components: {
    homeBanner: HomeBanner,
    carousel: Carousel,
    bottomBanner: BottomBanner
  }
}
</script>

<style>
#homeWrapper {
  position: relative;
  margin: 0 auto;
  padding: 0;
  flex-shrink: inherit;
}

</style>
